import {
  initialState,
  Actions,
  State,
  SELECT_ONE_JUDICIAL,
  SELECT_ONE_JUDICIAL_SUCCESS,
  SELECT_ONE_JUDICIAL_ERROR,
  RESET_SELECT_ONE_JUDICIAL,
} from "../../types/judicial/selectOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECT_ONE_JUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECT_ONE_JUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECT_ONE_JUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SELECT_ONE_JUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
